import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    userInfo: null,
    planStudyInfo: null,
    commonObj: {}
  },

  mutations: {
    userInfo(state, userInfo) {
      state.userInfo = userInfo;
    },
    planStudyInfo(state, planStudyInfo) {
      state.planStudyInfo = planStudyInfo;
    },
    commonObj(state, commonObj) {
      state.commonObj = commonObj;
    }
  },

  getters: {
    userInfo(state) {
      return state.userInfo;
    },
    planStudyInfo(state) {
      return state.planStudyInfo;
    },
    commonObj(state) {
			return state.commonObj;
		}
  }
});

export default store;